import { z } from "zod";

/**
 * Search-param schema for the `/reclaims` route.
 *
 * `reclaimId` is the numeric ReturnRequest id, so TanStack Router's default
 * search parser (`parseSearchWith(JSON.parse)`) hands us the **number** `42`
 * for `/reclaims?reclaimId=42` — but a hand-edited or quoted URL yields the
 * string. Coerce either into a number, and `.catch` anything unparseable
 * (`?reclaimId=abc` → NaN) back to "nothing selected": a thrown ZodError here
 * takes down the router's loader pipeline, which is exactly how every link to
 * a user detail view broke once before. See `usersSearchSchema`.
 */
export const reclaimsSearchSchema = z.object({
  reclaimId: z.coerce.number().int().optional().catch(undefined),
});

export type ReclaimsRouteSearch = z.infer<typeof reclaimsSearchSchema>;
